'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import UIButton from 'UIComponents/button/UIButton';
import { flash } from 'DesignData/actions/Flash';
const mapDispatchToProps = {
  flash
};

function CodeLink(props) {
  return /*#__PURE__*/_jsx(UIButton, {
    use: "link",
    onClick: () => {
      props.onLineClick(props.flash);
    },
    className: "code-line-column-link",
    children: /*#__PURE__*/_jsx("code", {
      children: props.message
    })
  }, "line-minification");
}

export default connect(null, mapDispatchToProps)(CodeLink);